<template>
    <add :title="$t('newAddAddress.modifyAddress')" :id="$route.query.id"/>
</template>

<script>
	import add from './add';
  // 多语言字典
  import {address as pageI18n} from "@config/i18n/page/address";

	export default {
		name: 'myAddressUpdate',
		components: {
			add
		},
    created() {
      // 加载当前页面的i18n字典配置
      this.$loadI18nConfig(pageI18n);
    }
	}
</script>

<style lang="scss" scoped>

</style>
